import gql from 'graphql-tag';

export const CREATE_CONTRACT = gql`
  mutation CreateContract($signature: String!) {
    createContract(signature: $signature)
  }
`;
